import { render } from "./App.vue?vue&type=template&id=47465e20&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=47465e20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47465e20"

export default script